$(document).ready(function(){
    var mySwiper1 = new Swiper('.fenBox .leftBox', {
        autoplay: true,//可选选项，自动滑动
        slidesPerView : 1,  
        navigation: {
            nextEl: '.rightButton1',
            prevEl: '.leftButton1',
          },
    })
    var kaSwiper = new Swiper('.kaBox .leftBox', {
        autoplay: true,//可选选项，自动滑动
        slidesPerView : 1,
        pagination: {
            el: '.kaPage',
          },
    })
    var riliListBox = new Swiper('.riliListBox', {
        autoplay: true,//可选选项，自动滑动
        slidesPerView : 4,
        navigation: {
            nextEl: '.listRight',
            prevEl: '.listLeft',
        },
    })
    var topSwiper = new Swiper('.topSwiper', {
        slidesPerView : 1
    })
    var contentSwiper = new Swiper('.contentSwiper', {
        slidesPerView : 1,
        pagination: {
            el: '.onePage',
        },
        controller: {
            control: topSwiper,
        }
    })

    $('.tools .item').click(function(){
        let index = $(this).index();
        contentSwiper.slideTo(index, 500, false);//切换到第一个slide，速度为1秒
      })

    var riliSwiper = new Swiper('.riliBox', {
        autoplay: true,//可选选项，自动滑动
        slidesPerView : 1,
        navigation: {
            nextEl: '.riliRight',
            prevEl: '.riliLeft',
        },
    })
    var imgSwiper = new Swiper('.imgBox', {
        // autoplay: true,//可选选项，自动滑动
        slidesPerView : 1,
        navigation: {
            nextEl: '.imgRight',
            prevEl: '.imgLeft',
        },
    })
    var mySwiper2 = new Swiper('.fenBox .rightBox', {
        autoplay: true,//可选选项，自动滑动
        slidesPerView : 1,  
        navigation: {
            nextEl: '.rightButton2',
            prevEl: '.leftButton2',
          },
    })
    var mySwiper4 = new Swiper('.mainBox .left', {
        autoplay: true,//可选选项，自动滑动
        slidesPerView : 1, 
        pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
    })
    var mySwiper3 = new Swiper('.zongBox', {
        autoplay: true,//可选选项，自动滑动
        slidesPerView : 2, 
        slidesPerColumn: 3, 
         slidesPerColumnFill:'row',  
        navigation: {
            nextEl: '.rightButton3',
            prevEl: '.leftButton3',
          },
    })
    let navStatus = 0
    $('.openNav').on('click',function(){
      if(navStatus == 0){
          $('.nav').show();
          navStatus = 1;
      }else{
          $('.nav').hide();
          navStatus = 0;
      }
      
  })
  $('.openNav1').on('click',function(){
      if(navStatus == 0){
          $('.navBox').show();
          navStatus = 1;
      }else{
          $('.navBox').hide();
          navStatus = 0;
      }
      
  })

    //知识问答
      function saveToken(token){
        return new Promise(function (resolve, reject) {
          $.ajax({
            url: 'https://xy.people.cn/rbbj_api/api/chat_token',
            type: 'POST',
            dataType: 'JSON',
            headers: {
              'Content-Type': 'application/json'
            },
            processData: false,
            data: JSON.stringify({
              "token": token
            }),
            success: function(res) {
              // console.log(res)
              if(res.message == "success"){
                resolve(true)
              }
            }
          })
        });
      }
      /*===
      AI对话
      ===*/
      const ENDPOINT = "https://xy.people.cn/rbbj_api/api/v2_02/chat/stream/";
      const userInput = document.getElementById('user-input');

      // 监听输入框的回车事件
      userInput.addEventListener('keydown', (event) => {
          if (event.key === "Enter") {
              // 处理回车事件
              sendMessage();
          }
      });

      const messages = [];

      let waiting = false;

      /**
     * 发送消息
     */
    function sendMessage() {

            if (!localStorage.getItem("chattoken")) {
              let timestamp = new Date().getTime();
              let token = md5(timestamp.toString())
              localStorage.setItem("chattoken", token);
            }

           // 等待
            if (waiting) {
                alert('等待回复中');
                return;
            }
            waiting = true;
            // 获取到用户的输入
            const message = userInput.value.trim();
            // 判断用户输入是否为空
            if (message === '') {
                alert('请输入内容');
                waiting = false;
                return;
            }
            // 将用户输入显示在聊天框中
            displayUserMessage(message);
            userInput.value = '';
            // 创建ChatGPT的回复，并获取到显示回复的容器
            const htmlSpanElement = displayChatGPTMessageAndGetContainer();
            // 发送消息到ChatGPT
            addMessage("user", message);
            const body = JSON.stringify({
                query: message,
                subject_id:"",
                detail_id:""
            });
            saveToken(localStorage.getItem("chattoken")).then((res)=>{
              ssePost(
                  // 请求地址
                  ENDPOINT+localStorage.getItem("chattoken"),
                  // 请求头
                  {"Content-Type": "application/json"},
                  // params，这里没有参数
                  {},
                  // body
                  body,
                  // 收到事件时的回调。这里将事件的data显示在htmlSpanElement中
                  (event) => {
                    const content = getContent(event.data);
                    // console.log("内容:",content) 
                    if (content) 
                        htmlSpanElement.innerHTML = content
                    },
                  // 结束时的回调。1.将消息添加到历史消息中 2.将等待状态设置为false
                  () => {addMessage("assistant", htmlSpanElement.innerHTML); waiting = false},
                  // 发生错误时的回调
                  (error) => {console.log(error)}
              );
            })

        }


      const contentPattern = /"content":"(.*?)"}/;

      /**
     * 获取回复内容
     */
     function getContent(data) {
          // console.log('回复内容:',JSON.parse(data).data)
          let subdata = JSON.parse(data).data;
          const match = decodeURIComponent(subdata);
          if (match) {
              return match;
          } else {
              return null;
          }
      }


      /**
       * 将消息添加到历史消息中
       */
      function addMessage(role, content) {
          messages.push({role: role, content: content});
      }

      let chatBox = document.getElementById('chat-box');
      /**
     * 将用户输入显示在聊天框中
     */
     function displayUserMessage(text) {
          const messageDiv = document.createElement('div');
          messageDiv.classList.add('message');

          const senderSpan = document.createElement('span');
          senderSpan.classList.add('sender');
          senderSpan.textContent = '问: ';

          const textSpan = document.createElement('span');
          textSpan.textContent = text;

          messageDiv.appendChild(senderSpan);
          messageDiv.appendChild(textSpan);

          chatBox.appendChild(messageDiv);
          chatBox.scrollTop = chatBox.scrollHeight;
      }
      /*
       * 将AI的回复显示在聊天框中
       */
      function displayChatGPTMessageAndGetContainer() {
          const messageDiv = document.createElement('div');
          messageDiv.classList.add('message');

          const senderSpan = document.createElement('span');
          senderSpan.classList.add('sender');
          senderSpan.textContent = '答: ';

          const textSpan = document.createElement('span');
          messageDiv.appendChild(senderSpan);
          messageDiv.appendChild(textSpan);

          chatBox.appendChild(messageDiv);
          chatBox.scrollTop = chatBox.scrollHeight;
          return textSpan;
      }
      function objectToQueryString(obj) {
            return Object.keys(obj)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
                .join('&');
        }
      /**
     * 发送POST请求并处理sse事件
     * @param url 请求地址
     * @param headers 请求头
     * @param params 请求参数
     * @param body 请求体
     * @param onEvent 收到事件时的回调
     * @param onEnd 结束时的回调
     * @param onError 发生错误时的回调
     */
      function ssePost(url, headers, params, body, onEvent, onEnd, onError) {
        if (Object.keys(params).length > 0) {
            url += '?' + objectToQueryString(params);
        }
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: body,
        }).then(async response => {
            if (!response.ok) {
                onError(new Error('Network response was not ok'));
                return;
            }
            // 异步处理响应流
            const reader = response.body.getReader();
            // 响应缓冲区
            let buffer = '';
            // 响应的前一个字符，用于判断一个事件是否结束
            let before = '';
            // 循环读取响应流，直到响应流结束
            while (true) {
                // 读取响应流
                const {done, value} = await reader.read();
                // 响应流结束
                if (done) {
                    break;
                }
                // 将响应流转换为文本
                const text = new TextDecoder().decode(value);
                // 遍历文本
                for (const element of text) {
                    // 判断是否为事件结束。连续两个'\n'表示一个事件结束
                    if (element === '\n' && before === '\n') {
                        // 将事件中的字段分割出来。例如：event: message \n data: hello world \n id: 123 \n\n
                        const eventAndData = buffer.substring(0, buffer.length - 1).split('\n');
                        // 将事件中的字段转换为对象, 例如：{event: message, data: hello world, id: 123}
                        const resultObject = {};
                        eventAndData.forEach(pair => {
                            const colonIndex = pair.indexOf(':');
                            if (colonIndex === -1) {
                                return;
                            }
                            resultObject[pair.substring(0, colonIndex)] = pair.substring(colonIndex + 2);
                        });
                        // 回调
                        onEvent(resultObject);
                        // 清空缓冲区
                        buffer = '';
                    } else
                    // 不是事件结束，将字符添加到缓冲区
                    {
                        before = element;
                        buffer += element;
                    }
                }
            }
            // 结束时的回调
            onEnd();
        }).catch(error => {
            // 发生错误时的回调
            onError(error);
        })
    }
    $('#send-button').on('click',function(){
      sendMessage();
    })
      /*====
      结束AI对话
      ===*/
})